import TokenIcon from './TokenIcon'

export default TokenIcon
